export function isJson(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (error) {
        return false;
    }
}

export function objectStringToJson(str) {
    // Use regular expression to find unquoted property names and add quotes
    return str.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2":');
}